import { createApp } from "vue";
import BranchSelectorMenu from "../vue/components/BranchSelectorMenu.vue";

const branchMenu = Object.freeze({
  component: "#branch-selector-component",
  button: "#company-dropdown"
})

export function mountBranchSelectorComponent(props) {
  const app = createApp(BranchSelectorMenu, {
    activeBranchId: props.activeBranchId,
    preferredBranchId: props.preferredBranchId,
    showMasterButton: props.showMasterButton,
    userId: props.userId,
    isGroupLevelDashboard: props.isGroupLevelDashboard,
    isGroupOwner: props.isGroupOwner,
    page: props.page,
    initialAreas: props.initialAreas || null,
    hasPro: props.groupPermissions ? props.groupPermissions.hasPro : false,
    hasTrial: props.groupPermissions ? props.groupPermissions.hasTrial : false,
  })
  window[branchMenu.component] = app.mount(branchMenu.component);
  window[branchMenu.component].initData(props.employments);
  addClickEventOnBranchMenu();
  closeBranchListOnClick();
}

function addClickEventOnBranchMenu() {
  $(branchMenu.button).on("click", () => {
    window[branchMenu.component].showBranchList()
  })
}

function closeBranchListOnClick() {
  $("#app").on("click", () => {
    window[branchMenu.component].closeBranchList()
  })
}

export function updateBranchListComponent(newEmploymentOrder) {
  window[branchMenu.component].updateBranchPos(newEmploymentOrder)
}
